import React, { PureComponent } from 'react';

import Checkbox from '../CheckBox/Checkbox';

interface CheckBoxGroupProps {
  checkBoxList: CheckBoxesProp[];
  onChange?: (value: CheckBoxesProp[], changed?: { name: string; value: boolean }) => void;
  isNeedCheckAll?: boolean;
  mainCheckBoxLabel?: string;
  colorLabel?: string;
  // checked?: string[];
}

export interface CheckBoxesProp {
  label: string | JSX.Element;
  flag?: boolean;
  name: string;
  id?: number;
  // resource_uri?: string;
}

interface CheckBoxGroupState {
  checkBoxGroupValue?: CheckBoxesProp[];
  isNeedCheckAll?: boolean;
}

export default class CheckBoxGroup extends PureComponent<CheckBoxGroupProps, CheckBoxGroupState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isNeedCheckAll: false,
    };
  }

  public componentDidMount(): void {
    const { checkBoxList } = this.props;
    this.setState({ checkBoxGroupValue: checkBoxList });
  }

  public componentDidUpdate(prevProps: CheckBoxGroupProps) {
    const { checkBoxList } = this.props;
    if (prevProps.checkBoxList !== checkBoxList) {
      this.setState({ checkBoxGroupValue: checkBoxList });
    }
  }

  private readonly changeHandler = (name: string, value: boolean) => {
    const { onChange } = this.props;
    const { checkBoxGroupValue } = this.state;
    if (checkBoxGroupValue !== undefined) {
      checkBoxGroupValue.forEach((item, index) => {
        if (item.name === name) {
          checkBoxGroupValue[index].flag = value;
          this.setState({ checkBoxGroupValue, isNeedCheckAll: false });
        }
      });
      if (onChange !== undefined) {
        onChange(checkBoxGroupValue, { name, value });
      }
    }
  };

  private readonly chooseAllCheckBoxes = () => {
    const { onChange } = this.props;
    const { checkBoxGroupValue, isNeedCheckAll } = this.state;
    if (checkBoxGroupValue !== undefined) {
      checkBoxGroupValue.forEach((item, index) => {
        checkBoxGroupValue[index].flag = !isNeedCheckAll;
      });
      this.setState({ checkBoxGroupValue, isNeedCheckAll: !isNeedCheckAll });
      if (onChange !== undefined) {
        onChange(checkBoxGroupValue);
      }
    }
  };

  private readonly getCheckAllCheckBox = () => {
    const { isNeedCheckAll } = this.state;
    const { mainCheckBoxLabel, colorLabel } = this.props;
    return (
      <Checkbox
        onChange={this.chooseAllCheckBoxes}
        checked={isNeedCheckAll}
        name={`checkAll_${mainCheckBoxLabel}`}
        label={mainCheckBoxLabel ? mainCheckBoxLabel : ''}
        colorLabel={colorLabel}
      />
    );
  };

  // private isChecked(name: string, flag?: boolean): boolean {
  //   // TODO
  // }

  private readonly getCheckBoxes = (): JSX.Element[] => {
    const { checkBoxGroupValue } = this.state;
    const { colorLabel } = this.props;
    if (checkBoxGroupValue !== undefined) {
      return checkBoxGroupValue.map((item, index) => (
        <Checkbox
          key={`${item.label}_${index}`}
          label={item.label}
          checked={item.flag}
          name={`${item.name}`}
          onChange={this.changeHandler}
          colorLabel={colorLabel}
        />
      ));
    }
    return [];
  };

  public render() {
    const { isNeedCheckAll } = this.props;
    if (isNeedCheckAll) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div>{this.getCheckAllCheckBox()}</div>
          <div style={{ paddingLeft: 35 }}>{this.getCheckBoxes()}</div>
        </div>
      );
    }
    return <div>{this.getCheckBoxes()}</div>;
  }
}
